import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../services';
import { DataCommunicationService } from '../../services/data_service/data-communication.service';
import { LoaderindicatorService } from '../../services/loaderindicator/loaderindicator.service';
import { CommonService } from '../../services/common_services/common.service';

@Component({
  selector: 'mgfw-customer-registration',
  templateUrl: './customer-registration.component.html',
  styleUrls: ['./customer-registration.component.css']
})
export class CustomerRegistrationComponent implements OnInit  {

  @Output() HidePopUpPar = new EventEmitter<void>();
  Brands = ["Mitsubishi","Renault","Hongqi","Dacia"];
  descriptionLength: number = 0;
  regForm: FormGroup;
  
  constructor(
    private translate: TranslateService,
    private modalService: ModalService,
    private commonService: CommonService,
    private dataCommunicationService: DataCommunicationService,
    private loaderservice: LoaderindicatorService,
    protected readonly fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.loadRegForm("");
    this.descriptionLength = this.regForm.get('Description').value.length || 0;
  }
  
  loadRegForm(mobileNumber: string){
    this.regForm = this.fb.group({
      HaveCar: [''],
      Brand: ['', [Validators.required]],
      RegistrationNumber: ['', [Validators.required,Validators.pattern('^[A-Za-z]{2}[0-9]{5}$')]],
      Name: ['', [Validators.required,Validators.maxLength(20)]],
      Email: ['', [Validators.required,Validators.maxLength(50),Validators.email]],
      Mobilenumber: ['', [Validators.required,Validators.pattern('^[0-9]{8}$')]],
      Description: [''],  // optional
      OwnOrLease: ['']    // optional
    });

    this.regForm.controls.Mobilenumber.patchValue(mobileNumber);
  }

  onRegSubmit(){
    if(this.regForm.valid){
      let data = this.regForm.value;
      this.translate.get("LoaderText.loading").subscribe((message) => {
        this.loaderservice.show(message);
      });
      this.dataCommunicationService.SendRegistrationEmail(data).subscribe((resp)=>{
        this.loaderservice.hide();
        if(resp){
          this.commonService.getSuccessMessage("LoaderText.EmailSent");
          this.HidePopUp("regModel");
        }
      },
      (error) => {
        this.loaderservice.hide();
        this.commonService.getErrorMessage("LoaderText.WentWrong");
      })
    }else{
      this.commonService.getErrorMessage("LoaderText.WentWrong");
    }
    
  }

  public HidePopUp(id) {
    this.HidePopUpPar.emit(id)
  }

}
